import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { PackagePanelDataProviderFactory } from '../factory/PackagePanelDataProviderFactory';
import { PackagePanelBaseDataProvider } from './PackagePanelBaseDataProvider';
import { GetCompanyFeaturesPayload, PackageData } from '../../types/package-data';
import { Feature } from '@nirvana/shared/constants';

export class PackagePanelRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PackagePanelDataProviderFactory;
  public dataProvider: PackagePanelBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PackagePanelDataProviderFactory(),
    });
  }

  public async addPackage(payload: PackageData): Promise<{ success: boolean; errorMessage?: string }> {
    return this.dataProvider.addPackage(payload);
  }

  public async updatePackage(payload: PackageData): Promise<{ success: boolean }> {
    return this.dataProvider.updatePackage(payload);
  }

  public async getFeaturesByCompany(payload: GetCompanyFeaturesPayload): Promise<Feature[]> {
    return this.dataProvider.getFeaturesByCompany(payload);
  }
}
